import Phaser from 'phaser';
import { BootScene } from '@/scenes/boot-scene';
import { MenuScene } from '@/scenes/menu-scene';
import { GameScene } from '@/scenes/game-scene';
import { PauseScene } from '@/scenes/pause-scene';
import { LevelTransitionScene } from '@/scenes/level-transition-scene';
import { GameOverScene } from '@/scenes/game-over-scene';
import { LeaderboardScene } from '@/scenes/leaderboard-scene';
import { InitialsEntryScene } from '@/scenes/initials-entry-scene';

export const TILE_SIZE = 16;
export const MAP_WIDTH_TILES = 28;
export const MAP_HEIGHT_TILES = 31;

export const GAME_WIDTH = MAP_WIDTH_TILES * TILE_SIZE;
export const GAME_HEIGHT = MAP_HEIGHT_TILES * TILE_SIZE + 64; // extra space for HUD

export const GAME_CONFIG: Phaser.Types.Core.GameConfig = {
  type: Phaser.AUTO,
  parent: 'game-container',
  width: GAME_WIDTH,
  height: GAME_HEIGHT,
  backgroundColor: '#050520',
  scale: {
    mode: Phaser.Scale.FIT,
    autoCenter: Phaser.Scale.CENTER_BOTH,
  },
  physics: {
    default: 'arcade',
    arcade: {
      gravity: { x: 0, y: 0 },
      debug: false,
    },
  },
  scene: [
    BootScene,
    MenuScene,
    GameScene,
    PauseScene,
    LevelTransitionScene,
    GameOverScene,
    LeaderboardScene,
    InitialsEntryScene,
  ],
};
